import { useCallback, useState } from "react";

/** Manages popover open state, supporting both controlled and uncontrolled modes. */
export function useControlledOpen(
  controlledOpen: boolean | undefined,
  onOpenChange?: (open: boolean) => void
): { open: boolean; setOpen: (next: boolean) => void } {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const setOpen = useCallback(
    (next: boolean) => {
      if (!isControlled) setInternalOpen(next);
      onOpenChange?.(next);
    },
    [isControlled, onOpenChange]
  );

  return { open, setOpen };
}
